/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-useless-constructor */
import { useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { GridColumn, Grid } from '@progress/kendo-react-grid';
import { withState } from '../../../../components/common/grid/WrappedGrid';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import { API_URL } from '../../../../utils/constants';
import createIcon from '../../../../static/img/createIcon.svg';
import GridWrapper from '~/src/components/common/GridWrapper';

export default function CategoriesList(): JSX.Element {
  const history = useHistory();
  const stateRef = useRef(null);
  const url = `${API_URL}/products/categories/get`;
  const StatefullGrid = withState(Grid, url);

  const productNameCell = (row) => {
    const { dataItem } = row;

    return (
      <td>
        <Link to={`/categories/edit/${dataItem.id}`}>{dataItem?.name}</Link>
      </td>
    );
  };

  return (
    <WhitePad>
      <TitleComponent
        title="Categories"
        titleRight="Create"
        onRightHandler={(): void => history.push('/categories/create')}
        iconRight={createIcon}
        titleLeft="Back"
        onLeftHandler={(): void => history.goBack()}
      />
      <GridWrapper>
        <StatefullGrid ref={stateRef}>
          <GridColumn field="name" title="Category Name" cell={(row) => productNameCell(row, stateRef)} />
        </StatefullGrid>
      </GridWrapper>
    </WhitePad>
  );
}
